import { render, staticRenderFns } from "./PageNotFound.vue?vue&type=template&id=7ca8a093&"
import script from "./PageNotFound.vue?vue&type=script&scoped=true&lang=js&"
export * from "./PageNotFound.vue?vue&type=script&scoped=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports